<div class="setup-container" #navContainer>
  <div class="shadow-nav-wrapper" aria-hidden="true">
    <nav mat-tab-nav-bar [tabPanel]="shadowPanel">
      @for (tab of permittedTabs; track tab.link) {
      <a mat-tab-link #shadowLink>{{ getLabel(tab) }}</a>
      }
      <a mat-tab-link #shadowMoreLink class="more-tab-link">
        {{ getMoreLabel() }}
        <mat-icon class="more-icon">arrow_drop_down</mat-icon>
      </a>
    </nav>
    <mat-tab-nav-panel #shadowPanel></mat-tab-nav-panel>
  </div>

  <nav mat-tab-nav-bar [tabPanel]="tabPanel" color="primary" class="setup-tab-nav">
    @for (tab of displayedTabs; track tab.link) {
    <a mat-tab-link [routerLink]="tab.link" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive">
      {{ getLabel(tab) }}
    </a>
    } @if (overflowTabs.length > 0) {
    <a mat-tab-link [matMenuTriggerFor]="moreMenu" [active]="isMoreTabActive" class="more-tab-link">
      {{ getMoreLabel() }}
      <mat-icon class="more-icon">arrow_drop_down</mat-icon>
    </a>
    }
  </nav>

  <mat-menu #moreMenu="matMenu" class="setup-more-menu">
    @for (tab of overflowTabs; track tab.link) {
    <a
      mat-menu-item
      [routerLink]="tab.link"
      routerLinkActive
      #rla="routerLinkActive"
      [class.active-overflow-item]="rla.isActive"
      (click)="onOverflowTabSelected(tab)"
    >
      {{ getLabel(tab) }}
    </a>
    }
  </mat-menu>

  <mat-tab-nav-panel #tabPanel class="setup-tab-panel">
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
